<div [ngxTippy]="dialer_tooltip" tippyName="dialer_tooltip"
  [tippyProps]="{arrow: false, placement: 'bottom', maxWidth: 500, theme: 'dark'}">
  <button
    class=" dialer-button inline-flex items-center justify-center p-2 bg-transparent text-gray-700 hover:bg-gray-200 focus:outline-none;"
    [ngClass]="{
    'dialer-active': toggleOverlay,
    'invisible': !isDialerOverlayReady
  }" (click)="togglePanel(!toggleOverlay)" #dialerOrigin *ngIf="showDialerButton"
    [disabled]="currentUserStatus === 'BUSY'">
    <mat-icon [svgIcon]="currentUserStatus === 'ONLINE' ? 'tabler:phone-call' : 'tabler:phone'"></mat-icon>
    <span class="busy-dot-icon" *ngIf="currentUserStatus !== 'ONLINE'"></span>
  </button>
</div>

<ng-template #dialer_tooltip let-hide >
  <div class="fade mx-auto w-auto h-auto tooltip text-white" *ngIf="this.integrations && this.integrations['zuperconnect']">
    <div class="py-2 flex items-center justify-start gap-3 tooltip-title">
      <span class="busy-dot"></span>
      <p class="text-sm">
        {{currentUserStatus === 'BUSY' ? "Call in progress. " + (isUserOnCallOtherTab ? 'Switch to Active tab' : '') :
        'You are unavailable. No calls will be received'}}
      </p>
    </div>
  </div>
</ng-template>